export default function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
}

export function clone_package_month(pkg, loop_tickets = false) {
    const copy = clone(pkg);
    copy.month = new Date(copy.month);

    if(!loop_tickets) {
        return copy;
    }

    for(var i = 0, l = copy.data.length; i < l; ++i) {
        copy.data[i].ticket.date = new Date(copy.data[i].ticket.date);

        for(var j = 0, ll = copy.data[i].tickets.length; j < ll; ++j) {
            copy.data[i].tickets[j].date = new Date(copy.data[i].tickets[j].date);
        }
    }

    return copy;
}